import React, { useMemo, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import ProductCard from '../ProductCard/ProductCard';
import { products, categories, navCategories } from '../../data/products';
import './Category.css';

const Category = () => {
  const { id } = useParams();
  const category = categories.find((c) => c.id === id);
  const navCategory = navCategories.find((c) => c.id === id);

  // Scroll to top when component mounts or category changes
useEffect(() => {
  window.scrollTo(0, 0);
}, [id]);

  const categoryProducts = useMemo(() => {
    return products.filter((p) => p.category.toLowerCase() === id.toLowerCase());
  }, [id]);

  if (!category) {
    return (
      <div className="category-page">
        <div style={{ textAlign: 'center', padding: '48px 24px' }}>
          <h1>Category Not Found</h1>
          <p style={{ color: '#666', marginBottom: '24px' }}>The category you're looking for doesn't exist.</p>
          <Link to="/shop" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', background: '#e21a2c', color: '#fff', textDecoration: 'none', borderRadius: '4px', fontWeight: 600 }}>
            <ArrowLeft size={16} /> Browse All Products
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="category-page">
      <nav className="product-breadcrumb">
        <Link to="/">Home</Link>
        <ChevronRight size={14} />
        <span>{category.name}</span>
      </nav>

      <div className="category-hero">
        <img src={category.image} alt={category.name} className="category-hero-image" />
        <div className="category-hero-overlay">
          <h1 className="category-hero-title">{category.name}</h1>
          <p className="category-hero-count">{category.count.toLocaleString()}+ items</p>
        </div>
      </div>

      {navCategory && (
        <div className="category-subcategories">
          <h3 className="category-subcategories-title">Shop by Department</h3>
          <div className="category-subcategories-list">
            {navCategory.subcategories.map((sub) => (
              <Link key={sub} to={`/category/${id}/${sub.toLowerCase().replace(/\s+/g, '-')}`} className="category-subcategory-link">
                {sub}
              </Link>
            ))}
          </div>
        </div>
      )}

      <div className="category-products">
        <div className="category-products-header">
          <h2 className="category-products-title">All {category.name}</h2>
          <Link to="/shop" style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px', color: '#0066cc', textDecoration: 'none' }}>
            <ArrowLeft size={16} /> Back to All
          </Link>
        </div>

        <div className="category-products-grid">
          {categoryProducts.length > 0 ? (
            categoryProducts.map((product) => <ProductCard key={product.id} product={product} />)
          ) : (
            <div className="category-empty">
              <h3>No products found</h3>
              <p>Check back later for new arrivals.</p>
              <Link to="/shop" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 24px', background: '#e21a2c', color: '#fff', textDecoration: 'none', borderRadius: '4px', fontWeight: 600, marginTop: '16px' }}>
                Browse All Products
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Category;
